import { useContext } from 'react'
import styled, { keyframes } from 'styled-components'
import CreationToolSourceEditor from '../../../types/source-editor'
import { CreationToolUploadContext } from '../manager'
import { CreationToolUploadSource } from '../types'
import Dropdown from './dropdown'

const menuFadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const EditDropdown = styled(Dropdown)`
    display: none;
`

const Edit = styled.div`
    padding-bottom: 6px;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 500;

    &:hover ${EditDropdown} {
        animation: 0.15s ease-out 0.25s 1 normal backwards ${menuFadeIn};
        display: block;
    }
`

const Button = styled.div`
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    line-height: 28px;

    i {
        display: inline-block;
        font-size: 18px;
        line-height: 26px;
        margin-left: -1px;
        transform: rotate(90deg);
        vertical-align: top;
    }
`

type Props = {
    className?: string
    source: CreationToolUploadSource
    setIsPreviewing?: (isPreviewing: boolean) => void
}

const CreationUploadItemEditMenu = ({ className, source, setIsPreviewing }: Props) => {
    const { setEditing } = useContext(CreationToolUploadContext)

    const onEditorClick = (defaultEditor?: CreationToolSourceEditor) => {
        setEditing({
            source,
            defaultEditor,
        })
    }

    return (
        <Edit className={className}>
            <Button onClick={() => onEditorClick()}>
                Edit <i className="ss-ellipsis" />
            </Button>
            <EditDropdown
                {...{
                    source,
                    setIsPreviewing,
                    onEditorClick,
                }}
            />
        </Edit>
    )
}

export default CreationUploadItemEditMenu
